<template>
  <a-spin :spinning="loading">
    <a-card :bordered="false">
      <a-form :form="form" >
        <a-row>
          <a-col :span="24">
            <a-divider orientation="left">
              合同信息
            </a-divider>
          </a-col>
          <a-col :span="12">
            <a-form-item label="系统编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['business_no']" disabled/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="合同号" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['contract_number']" disabled/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="合同名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['contract_name', {rules: [{required: true, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" placeholder="名称" allow-clear/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="客户" :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-select
                mode="multiple"
                option-label-prop="tt"
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="null"
                show-search
                v-decorator="[
                  'client_ids',
                  {
                    rules: [
                      { required: true, message: '选择客户' },
                    ],
                  },
                ]"
                placeholder="请输入客户"
                :default-active-first-option="false"
                @search="this.clientSearch"
                @change="handleClientChange"
              >
                <a-select-option v-for="d in clientList" :key="d.client_id" :tt="d.client">
                  {{ d.client }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="仓储租赁期限" :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-range-picker
                @change="time"
                format="YYYY-MM-DD"
                style="width: 100%"
                v-decorator="['lease_date', {rules: [{required: false, message: '必填项，请填写信息'}]}]">
                <template slot="dateRender" slot-scope="current">
                  <div class="ant-calendar-date" :style="getCurrentStyle(current)">
                    {{ current.date() }}
                  </div>
                </template>
              </a-range-picker>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="储存地" :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-input allow-clear v-decorator="['storage_location', {rules: [{required: false, message: '必填项，请填写信息'}, {max:256, message: '输入超出长度限制'}]}]" placeholder="请输入" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="库管方" :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-input allow-clear v-decorator="['warehouse_manager', {rules: [{required: false, message: '必填项，请填写信息'}, {max:128, message: '输入超出长度限制'}]}]" placeholder="请输入" />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-divider orientation="left">
              支付信息
            </a-divider>
          </a-col>
          <a-col :span="12">
            <a-form-item label="支付方式" :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-select
                v-decorator="[
                  'payment_method',
                  {
                    rules: [
                      { required: true, message: '请选择' }
                    ],
                  },
                ]"
                placeholder="选择"
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
              >
                <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.trade_payment_method">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="计费方式" :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-input allow-clear v-decorator="['billing_method', {rules: [{required: false, message: '必填项，请填写信息'}, {max:64, message: '输入超出长度限制'}]}]" placeholder="请输入" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="支付周期" :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-input allow-clear v-decorator="['payment_cycle', {rules: [{required: false, message: '必填项，请填写信息'}, {max:64, message: '输入超出长度限制'}]}]" placeholder="请输入" />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-divider orientation="left">
              财务信息
            </a-divider>
          </a-col>
          <a-col :span="12">
            <a-form-item label="税率" :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-input-number allow-clear v-decorator="['tax_rate', {initialValue: 0, rules: [{required: true, message: '必填项，请填写信息'}]}]"/>%
            </a-form-item>
          </a-col>
        </a-row>
        <a-form-item v-bind="buttonCol">
          <a-row>
            <a-col offset="8" span="6">
              <a-button type="primary" html-type="submit" @click="handleSubmit">提交</a-button>
            </a-col>
            <a-col span="10">
              <a-button @click="handleGoBack">返回</a-button>
            </a-col>
          </a-row>
        </a-form-item>
      </a-form>
    </a-card>
  </a-spin>
</template>

<script>
import moment from 'moment'
import pick from 'lodash.pick'
import { storage_contract_update, storage_contract_list } from '@/api/trade_contract'
import { project_client_list } from '@/api/trade_project_client'
import debounce from 'lodash/debounce'
export default {
  name: 'TableEdit',
  props: {
    record: {
      type: [Object, String],
      default: ''
    }
  },
  data () {
    this.clientSearch = debounce(this.handleClientSearch, 800)
    return {
      labelCol: {
        xs: { span: 6 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 }
      },
      buttonCol: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12, offset: 5 }
        }
      },
      form: this.$form.createForm(this),
      id: 0,
      sell_contract_id: 0,
      project_id: undefined,
      type: 0,
      loading: false,
      data: {},
      clientList: [],
      lease_start_date: undefined,
      lease_end_date: undefined,
      fields: ['business_no', 'contract_number', 'contract_name', 'lease_date', 'client_ids',
        'storage_location', 'warehouse_manager', 'billing_method', 'payment_cycle', 'tax_rate', 'payment_method']
    }
  },
  mounted () {
    this.loadContract()
  },
  methods: {
    moment,
    handleGoBack () {
      this.$router.go(-1)
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    loadContract () {
      this.loading = true
      storage_contract_list({ id: this.$route.params.id }).then(res => {
        const list = res.data.entries
        if (list && list.length > 0) {
          this.data = list[0]
          this.id = this.data.id
          this.loadEditInfo(this.data)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    handleClientSearch (value) {
      project_client_list({ name: value, project_id: this.project_id }).then((res) => {
        const result = res.data.entries || []
        this.clientList = !value ? (result.length > 5 ? result.slice(0, 5) : result) : result
      })
    },
    handleClientChange (value) {
      if (value === undefined) {
        this.handleClientSearch(value)
      }
    },
    handleSubmit () {
      const { form: { validateFields } } = this
      validateFields((err, values) => {
        console.log('我要提交接口', values, err)
        if (!err) {
          values['sell_contract_id'] = this.sell_contract_id
          if (this.lease_start_date !== undefined && this.lease_end_date !== undefined) {
            values['lease_start_date'] = this.lease_start_date
            values['lease_end_date'] = this.lease_end_date
          }
          this.loading = true
          storage_contract_update(values, this.id).then((res) => {
            if (res.code === 1000) {
              this.handleGoBack()
              console.log(res, '修改成功')
            }
          }).finally(() => {
            this.loading = false
          })
        }
      })
    },
    loadEditInfo (data) {
      const { form } = this
      console.log(`将加载 ${this} 信息到表单`)
      this.id = data.id
      this.sell_contract_id = data.sell_contract_id
      this.project_id = data.project_id
      new Promise((resolve) => {
        setTimeout(resolve, 0)
      }).then(() => {
        const formData = pick(data, this.fields)
        formData.payment_method = '' + formData.payment_method
        const hasValidLeaseDate = data.lease_start_date !== undefined && data.lease_start_date !== '1970-01-01' && data.lease_end_date !== undefined && data.lease_end_date !== '1970-01-01'
        if (hasValidLeaseDate) {
          formData.lease_date = [
            moment(data.lease_start_date),
            moment(data.lease_end_date) ]
          this.lease_start_date = data.lease_start_date
          this.lease_end_date = data.lease_end_date
        } else {
          formData.lease_date = undefined
        }
        form.setFieldsValue(formData)
      }).finally(() => {
        this.handleClientSearch(undefined)
      })
    },
    time (dates, dateStrings) {
      this.lease_start_date = dateStrings[0]
      this.lease_end_date = dateStrings[1]
    },
    getCurrentStyle (current, today) {
      const style = {}
      if (current.date() === 1) {
        style.border = '1px solid #1890ff'
        style.borderRadius = '50%'
      }
      return style
    }
  }
}
</script>
